var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_info",
    "data-name": "icona info",
    transform: "translate(-367 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info",
    d: "M.625,13.257H1.25V8.743H.625A.625.625,0,0,1,0,8.118V6.625A.625.625,0,0,1,.625,6h3.5a.625.625,0,0,1,.625.625v6.632h.625A.625.625,0,0,1,6,13.882v1.493A.625.625,0,0,1,5.375,16H.625A.625.625,0,0,1,0,15.375V13.882A.625.625,0,0,1,.625,13.257ZM3,0A2.25,2.25,0,1,0,5.25,2.25,2.25,2.25,0,0,0,3,0Z",
    transform: "translate(372 20)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_767",
    "data-name": "Rettangolo 767",
    transform: "translate(367 20)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.945f36d96b8d4b0c3385df0a9cdafe91.svg";
export { ForwardRef as ReactComponent };